module.exports = __webpack_public_path__ + "media/images/emblems/Laufen-Uhwiesen-blazon-e0a93867af43c4029d7ae15dd08aa989.svg";